import { render } from "./picturesData.vue?vue&type=template&id=22a411ec&ts=true"
import script from "./picturesData.vue?vue&type=script&lang=ts"
export * from "./picturesData.vue?vue&type=script&lang=ts"

import "./picturesData.vue?vue&type=style&index=0&id=22a411ec&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__